import { WithAuthorization } from "../../context";
import { useTranslation } from "react-i18next";
import { Box, Button, Center, Flex, Heading, useBreakpointValue, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useGetAllSupplierCategories, useGetAllSuppliers } from "../../hooks/query";
import { showErrorToast } from "../../utils";
import { useGetSuppliersSpendsByLocation } from "../../hooks/query/reports";
import { worldCountries } from "../SupplierAdminDashboard/helpers";
import { FilterSupplierByCategory } from "../SupplierAdminDashboard/components";
import { routes, supplierAdminDashboardKey } from "../../config";
import * as React from "react";
import { FilterBySupplier, SuppliersLocationsMap } from "./components";

function SuppliersLocations() {
  const { t } = useTranslation("translation", {
    keyPrefix: "suppliersLocations"
  });
  const toast = useToast();
  const navigate = useNavigate();

  const [mapData, setMapData] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState("");
  const [supplierFilter, setSupplierFilter] = useState("");

  const buttonsContainerFlow = useBreakpointValue({
    base: "column",
    xl: "row"
  });

  const {
    data: categories = []
  } = useGetAllSupplierCategories({
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  const {
    data: suppliers = []
  } = useGetAllSuppliers({
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  useGetSuppliersSpendsByLocation({ year: 2023, categoryId: categoryFilter, supplierId: supplierFilter }, {
    onSuccess: (data) => {
      if (data && Object.keys(data)?.length > 0) {
        const newData = Object.keys(data).map(country => {
          return {
            id: worldCountries.find(obj => obj.properties.name.toLowerCase() === country.toLowerCase())?.id ?? country,
            value: data[country].reduce((acc, o) => acc + Number(o.totalAmount), 0) ?? 0,
            suppliers: data[country]
          };
        });
        setMapData(newData);
      } else {
        setMapData([]);
      }
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  return (
    <>
      <Center marginBlock={5} marginInline={8}>
        <Heading size="md">
          {t("header")}{supplierFilter && supplierFilter !== "" ?
          ` ${t("of")} "${suppliers.find(supp => supp.id === supplierFilter)?.name ?? supplierFilter}"` : ""}
          {`${categoryFilter && categoryFilter !== "" ?
            ` ${t("inCategory")} "${categories.find(cat => cat.id === categoryFilter)?.name ?? ""}"` : ""}`}
        </Heading>
      </Center>
      <Flex
        marginInline={8}
        justifyContent="space-between"
        flexFlow={buttonsContainerFlow}
        alignItems={buttonsContainerFlow === "row" ? "end" : "center"}
      >
        <Flex gap={2}>
          <Box>
            <FilterSupplierByCategory
              categoryFilter={categoryFilter}
              setCategoryFilter={setCategoryFilter}
            />
          </Box>
          <Box>
            <FilterBySupplier
              suppliers={suppliers}
              supplierFilter={supplierFilter}
              setSupplierFilter={setSupplierFilter}
            />
          </Box>
        </Flex>
        <Button
          color={"esg_blue"}
          textDecoration="underline"
          fontWeight="bold"
          marginInlineStart={4}
          variant="link"
          onClick={() => {
            navigate(routes[supplierAdminDashboardKey]);
          }}
        >
          {t("returnToSupplierDashboard")}
        </Button>
      </Flex>
      <SuppliersLocationsMap mapData={mapData} isDataFiltered={categoryFilter !== "" || supplierFilter !== ""} />
    </>
  );
}

export default WithAuthorization(SuppliersLocations);